import React, { useContext } from "react";

import { ResultsContext, ResultsEventContext } from "@state/context/results";
import range from "lodash/range";

import { calculateTableBodyColspan, tbodyColspanMax } from "./utils";

export default function ResultsEventEmptySpaces() {
	const result = useContext(ResultsContext);
	const event = useContext(ResultsEventContext);
	const tbodyColspan = calculateTableBodyColspan(result.sport.abrv);

	if (tbodyColspan > tbodyColspanMax) {
		return null;
	}

	return (
		<>
			{range(tbodyColspanMax - tbodyColspan).map((item, idx) => {
				return (
					<th
						key={`${event.id}-${idx}`}
						className="table--results__body__data is-empty"
					>
						&nbsp;
					</th>
				);
			})}
		</>
	);
}
